import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  "aria-live": "assertive",
  class: "pointer-events-none fixed top-32 left-0 inset-0 flex px-4 py-6 items-start sm:p-6 z-50"
}
const _hoisted_2 = { class: "flex w-full flex-col items-center space-y-4 sm:items-end" }
const _hoisted_3 = {
  key: 0,
  class: "pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-gray-100 shadow-lg ring-1 ring-black ring-opacity-5"
}
const _hoisted_4 = { class: "p-4" }
const _hoisted_5 = { class: "flex items-start" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-0" }, null, -1)
const _hoisted_7 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-sm text-gray-500" }, "De fleste funktioner er de-aktiveret.", -1)
const _hoisted_9 = {
  key: 0,
  class: "pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-gray-100 shadow-lg ring-1 ring-black ring-opacity-5"
}
const _hoisted_10 = { class: "p-4" }
const _hoisted_11 = { class: "flex items-start" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-0" }, null, -1)
const _hoisted_13 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_14 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_15 = { class: "flex flex-col mt-16" }
const _hoisted_16 = { class: "flex flex-col text-sm text-gray-400 px-2 py-3" }
const _hoisted_17 = { class: "flex flex-row justify-start items-start content-stretch" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow text-sm text-gray-400 px-5" }, "Tur", -1)
const _hoisted_19 = { class: "w-10 text-right" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "30",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10 8.5C10.8281 8.5 11.5 9.17188 11.5 10C11.5 10.8281 10.8281 11.5 10 11.5C9.17188 11.5 8.5 10.8281 8.5 10C8.5 9.17188 9.17188 8.5 10 8.5ZM8.5 5.25C8.5 6.07812 9.17188 6.75 10 6.75C10.8281 6.75 11.5 6.07812 11.5 5.25C11.5 4.42188 10.8281 3.75 10 3.75C9.17188 3.75 8.5 4.42188 8.5 5.25ZM8.5 14.75C8.5 15.5781 9.17188 16.25 10 16.25C10.8281 16.25 11.5 15.5781 11.5 14.75C11.5 13.9219 10.8281 13.25 10 13.25C9.17188 13.25 8.5 13.9219 8.5 14.75Z",
    fill: "#858E97"
  })
], -1)
const _hoisted_21 = {
  key: 0,
  class: "py-1",
  role: "none"
}
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 1,
  class: "py-1",
  role: "none"
}
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 2,
  class: "py-1",
  role: "none"
}
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 3,
  class: "py-1",
  role: "none"
}
const _hoisted_28 = {
  class: "py-1",
  role: "none"
}
const _hoisted_29 = ["disabled"]
const _hoisted_30 = {
  class: "py-1",
  role: "none"
}
const _hoisted_31 = ["disabled"]
const _hoisted_32 = { class: "flex flex-row justify-start items-start" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "w-4 flex-shrink h-14 flex py-2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "fill-secondary rotate-180",
    width: "20",
    height: "40",
    viewBox: "0 0 9 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M8.02899 20.4773L2.56306 25.9432C2.29944 26.2068 1.87206 26.2068 1.60847 25.9432L0.97096 25.3057C0.707794 25.0425 0.707288 24.616 0.969835 24.3522L5.30168 20L0.969835 15.6478C0.707288 15.384 0.707794 14.9575 0.97096 14.6943L1.60847 14.0568C1.87208 13.7932 2.29947 13.7932 2.56306 14.0568L8.02896 19.5227C8.29257 19.7863 8.29257 20.2137 8.02899 20.4773Z" })
  ])
], -1)
const _hoisted_34 = { class: "flex flex-col" }
const _hoisted_35 = { class: "px-1 text-xl font-medium text-primary line-clamp-2" }
const _hoisted_36 = { class: "px-1 text-base font-medium text-primary" }
const _hoisted_37 = { class: "space-y-4 overflow-hidden" }
const _hoisted_38 = { class: "relative bg-white px-6 py-5 text-sm text-gray-400" }
const _hoisted_39 = { class: "flex mb-4" }
const _hoisted_40 = { class: "grow" }
const _hoisted_41 = { class: "text-xl font-medium text-primary" }
const _hoisted_42 = { class: "text-sm text-gray-400" }
const _hoisted_43 = { class: "text-sm text-gray-400" }
const _hoisted_44 = { class: "grow-0" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10 2.88889C8.06694 2.88889 6.5 4.45583 6.5 6.38889C6.5 7.95166 8.7875 10.8 9.66389 11.8339C9.84139 12.0433 10.1589 12.0433 10.3361 11.8339C11.2125 10.8 13.5 7.95166 13.5 6.38889C13.5 4.45583 11.9331 2.88889 10 2.88889ZM10 7.55555C9.35556 7.55555 8.83333 7.03333 8.83333 6.38889C8.83333 5.74444 9.35556 5.22222 10 5.22222C10.6444 5.22222 11.1667 5.74444 11.1667 6.38889C11.1667 7.03333 10.6444 7.55555 10 7.55555ZM2.55889 8.8875C2.39394 8.95347 2.25254 9.06735 2.15292 9.21445C2.0533 9.36155 2.00004 9.53512 2 9.71278V16.6661C2 16.9806 2.3175 17.1956 2.60944 17.0789L6.44444 15.3333V8.85889C6.19889 8.415 5.99806 7.98277 5.85417 7.56944L2.55889 8.8875ZM10 12.8797C9.60917 12.8797 9.23944 12.7081 8.98583 12.4086C8.43972 11.7642 7.85889 11.0303 7.33333 10.2775V15.3331L12.6667 17.1108V10.2778C12.1411 11.0303 11.5606 11.7644 11.0142 12.4089C10.7606 12.7081 10.3908 12.8797 10 12.8797ZM17.3906 7.36555L13.5556 9.11111V17.1111L17.4411 15.5569C17.6061 15.491 17.7475 15.3771 17.8471 15.23C17.9468 15.0829 18 14.9093 18 14.7317V7.77833C18 7.46389 17.6825 7.24889 17.3906 7.36555Z",
    fill: "white"
  })
], -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = /*#__PURE__*/_createStaticVNode("<svg width=\"37\" height=\"40\" viewBox=\"0 0 37 40\" fill=\"#9cafa3\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_465_856)\"><path d=\"M12.5418 24.5473L18.2676 18.8215C18.3961 18.693 18.6039 18.693 18.7324 18.8215L24.4582 24.5473C24.5867 24.6758 24.5867 24.8836 24.4582 25.0121L23.9168 25.5535C23.7883 25.682 23.5805 25.682 23.452 25.5535L18.5 20.6125L13.5481 25.5535C13.4196 25.682 13.2117 25.682 13.0832 25.5535L12.5418 25.0121C12.4133 24.8836 12.4133 24.6758 12.5418 24.5473ZM12.5418 20.6371L13.0832 21.1785C13.2117 21.307 13.4196 21.307 13.5481 21.1785L18.5 16.2375L23.452 21.1785C23.5805 21.307 23.7883 21.307 23.9168 21.1785L24.4582 20.6371C24.5867 20.5086 24.5867 20.3008 24.4582 20.1723L18.7324 14.4465C18.6039 14.318 18.3961 14.318 18.2676 14.4465L12.5418 20.1723C12.4133 20.3008 12.4133 20.5086 12.5418 20.6371Z\" fill=\"#c8dbcf\"></path></g></svg><div class=\"text-sm font-medium text-gray-500 flex items-center justify-center align-middle\"> Vis tidligere stop </div><svg width=\"37\" height=\"40\" viewBox=\"0 0 37 40\" fill=\"#9cafa3\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_465_856)\"><path d=\"M12.5418 24.5473L18.2676 18.8215C18.3961 18.693 18.6039 18.693 18.7324 18.8215L24.4582 24.5473C24.5867 24.6758 24.5867 24.8836 24.4582 25.0121L23.9168 25.5535C23.7883 25.682 23.5805 25.682 23.452 25.5535L18.5 20.6125L13.5481 25.5535C13.4196 25.682 13.2117 25.682 13.0832 25.5535L12.5418 25.0121C12.4133 24.8836 12.4133 24.6758 12.5418 24.5473ZM12.5418 20.6371L13.0832 21.1785C13.2117 21.307 13.4196 21.307 13.5481 21.1785L18.5 16.2375L23.452 21.1785C23.5805 21.307 23.7883 21.307 23.9168 21.1785L24.4582 20.6371C24.5867 20.5086 24.5867 20.3008 24.4582 20.1723L18.7324 14.4465C18.6039 14.318 18.3961 14.318 18.2676 14.4465L12.5418 20.1723C12.4133 20.3008 12.4133 20.5086 12.5418 20.6371Z\" fill=\"#c8dbcf\"></path></g></svg>", 3)
const _hoisted_50 = [
  _hoisted_47
]
const _hoisted_51 = {
  key: 1,
  class: "flex items-center gap-x-3 px-2 py-6 text-gray-500"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin h-5 w-5",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "Henter turen…", -1)
const _hoisted_54 = [
  _hoisted_52,
  _hoisted_53
]
const _hoisted_55 = {
  key: 2,
  role: "list",
  class: "p-0"
}
const _hoisted_56 = {
  key: 0,
  class: "m-0 flex items-center p-0 relative"
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", {
  class: "absolute left-2 top-4 -ml-px mt-0.5 h-full w-0.5 bg-gray-100",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_58 = { class: "flex items-center shrink-0" }
const _hoisted_59 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col grow\"><div class=\"text-sm text-gray-400\">-</div><div class=\"text-base font-medium leading-5 text-gray-800\">Defrost</div></div><div class=\"flex items-center shrink-0\"><svg class=\"w-8\" viewBox=\"0 0 33 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20.029 20.4773L14.5631 25.9432C14.2995 26.2068 13.8721 26.2068 13.6085 25.9432L12.971 25.3057C12.7079 25.0425 12.7073 24.616 12.9699 24.3522L17.3017 20L12.9699 15.6478C12.7073 15.384 12.7079 14.9575 12.971 14.6943L13.6085 14.0568C13.8721 13.7932 14.2995 13.7932 14.5631 14.0568L20.029 19.5227C20.2926 19.7863 20.2926 20.2137 20.029 20.4773Z\" fill=\"#E5E7EB\"></path></svg></div>", 2)
const _hoisted_61 = {
  key: 1,
  class: "m-0 flex items-center p-0 relative"
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", {
  class: "absolute left-2 top-4 -ml-px mt-0.5 h-full w-0.5 bg-gray-100",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_63 = { class: "flex items-center shrink-0" }
const _hoisted_64 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col grow\"><div class=\"text-sm text-gray-400\">Det er nødvendigt at tage et billede før man kan starte</div><div class=\"text-base font-medium leading-5 text-gray-800\">Tag et billede</div></div><div class=\"flex items-center shrink-0\"><svg class=\"w-8\" viewBox=\"0 0 33 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20.029 20.4773L14.5631 25.9432C14.2995 26.2068 13.8721 26.2068 13.6085 25.9432L12.971 25.3057C12.7079 25.0425 12.7073 24.616 12.9699 24.3522L17.3017 20L12.9699 15.6478C12.7073 15.384 12.7079 14.9575 12.971 14.6943L13.6085 14.0568C13.8721 13.7932 14.2995 13.7932 14.5631 14.0568L20.029 19.5227C20.2926 19.7863 20.2926 20.2137 20.029 20.4773Z\" fill=\"#E5E7EB\"></path></svg></div>", 2)
const _hoisted_66 = { class: "flex w-full z-10 gap-x-4 no-underline py-1.5" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center shrink-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-4 h-4" }, " ")
], -1)
const _hoisted_68 = { class: "flex flex-col grow items-start justify-center" }
const _hoisted_69 = ["innerHTML"]
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center shrink-0" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-8",
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M20.029 20.4773L14.5631 25.9432C14.2995 26.2068 13.8721 26.2068 13.6085 25.9432L12.971 25.3057C12.7079 25.0425 12.7073 24.616 12.9699 24.3522L17.3017 20L12.9699 15.6478C12.7073 15.384 12.7079 14.9575 12.971 14.6943L13.6085 14.0568C13.8721 13.7932 14.2995 13.7932 14.5631 14.0568L20.029 19.5227C20.2926 19.7863 20.2926 20.2137 20.029 20.4773Z",
      fill: "#E5E7EB"
    })
  ])
], -1)
const _hoisted_71 = { class: "m-0 flex items-center p-0 relative" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", {
  class: "absolute left-2 top-4 -ml-px mt-0.5 h-full w-0.5 bg-gray-100",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_73 = ["onClick"]
const _hoisted_74 = { class: "flex items-center shrink-0" }
const _hoisted_75 = { class: "flex flex-col grow" }
const _hoisted_76 = { class: "text-sm text-gray-400" }
const _hoisted_77 = { class: "text-base font-medium leading-5 text-gray-800" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center shrink-0" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-8",
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M20.029 20.4773L14.5631 25.9432C14.2995 26.2068 13.8721 26.2068 13.6085 25.9432L12.971 25.3057C12.7079 25.0425 12.7073 24.616 12.9699 24.3522L17.3017 20L12.9699 15.6478C12.7073 15.384 12.7079 14.9575 12.971 14.6943L13.6085 14.0568C13.8721 13.7932 14.2995 13.7932 14.5631 14.0568L20.029 19.5227C20.2926 19.7863 20.2926 20.2137 20.029 20.4773Z",
      fill: "#E5E7EB"
    })
  ])
], -1)
const _hoisted_79 = {
  key: 2,
  class: "m-0 flex items-center p-0 relative"
}
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", {
  class: "absolute left-2 top-4 -ml-px mt-0.5 h-full w-0.5 bg-gray-100",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_81 = { class: "flex items-center shrink-0" }
const _hoisted_82 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col grow\"><div class=\"text-sm text-gray-400\">Det er nødvendigt at tage et billede før man kan afslutte</div><div class=\"text-base font-medium leading-5 text-gray-800\">Tag et billede</div></div><div class=\"flex items-center shrink-0\"><svg class=\"w-8\" viewBox=\"0 0 33 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20.029 20.4773L14.5631 25.9432C14.2995 26.2068 13.8721 26.2068 13.6085 25.9432L12.971 25.3057C12.7079 25.0425 12.7073 24.616 12.9699 24.3522L17.3017 20L12.9699 15.6478C12.7073 15.384 12.7079 14.9575 12.971 14.6943L13.6085 14.0568C13.8721 13.7932 14.2995 13.7932 14.5631 14.0568L20.029 19.5227C20.2926 19.7863 20.2926 20.2137 20.029 20.4773Z\" fill=\"#E5E7EB\"></path></svg></div>", 2)
const _hoisted_84 = { class: "m-0 flex items-center p-0 relative" }
const _hoisted_85 = { class: "flex items-center shrink-0" }
const _hoisted_86 = { class: "flex flex-col grow" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-gray-400" }, "-", -1)
const _hoisted_88 = { class: "text-base font-medium leading-5 text-gray-800" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center shrink-0" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-8",
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M20.029 20.4773L14.5631 25.9432C14.2995 26.2068 13.8721 26.2068 13.6085 25.9432L12.971 25.3057C12.7079 25.0425 12.7073 24.616 12.9699 24.3522L17.3017 20L12.9699 15.6478C12.7073 15.384 12.7079 14.9575 12.971 14.6943L13.6085 14.0568C13.8721 13.7932 14.2995 13.7932 14.5631 14.0568L20.029 19.5227C20.2926 19.7863 20.2926 20.2137 20.029 20.4773Z",
      fill: "#E5E7EB"
    })
  ])
], -1)
const _hoisted_90 = /*#__PURE__*/_createStaticVNode("<svg width=\"37\" height=\"40\" viewBox=\"0 0 37 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g transform=\"rotate(180 18.5 20)\"><g clip-path=\"url(#clip0_465_856)\"><path d=\"M12.5418 24.5473L18.2676 18.8215C18.3961 18.693 18.6039 18.693 18.7324 18.8215L24.4582 24.5473C24.5867 24.6758 24.5867 24.8836 24.4582 25.0121L23.9168 25.5535C23.7883 25.682 23.5805 25.682 23.452 25.5535L18.5 20.6125L13.5481 25.5535C13.4196 25.682 13.2117 25.682 13.0832 25.5535L12.5418 25.0121C12.4133 24.8836 12.4133 24.6758 12.5418 24.5473ZM12.5418 20.6371L13.0832 21.1785C13.2117 21.307 13.4196 21.307 13.5481 21.1785L18.5 16.2375L23.452 21.1785C23.5805 21.307 23.7883 21.307 23.9168 21.1785L24.4582 20.6371C24.5867 20.5086 24.5867 20.3008 24.4582 20.1723L18.7324 14.4465C18.6039 14.318 18.3961 14.318 18.2676 14.4465L12.5418 20.1723C12.4133 20.3008 12.4133 20.5086 12.5418 20.6371Z\" fill=\"#c8dbcf\"></path></g></g></svg><div class=\"text-sm font-medium text-gray-500 flex items-center justify-center align-middle\"> Vis senere stop </div><svg width=\"37\" height=\"40\" viewBox=\"0 0 37 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g transform=\"rotate(180 18.5 20)\"><g clip-path=\"url(#clip0_465_856)\"><path d=\"M12.5418 24.5473L18.2676 18.8215C18.3961 18.693 18.6039 18.693 18.7324 18.8215L24.4582 24.5473C24.5867 24.6758 24.5867 24.8836 24.4582 25.0121L23.9168 25.5535C23.7883 25.682 23.5805 25.682 23.452 25.5535L18.5 20.6125L13.5481 25.5535C13.4196 25.682 13.2117 25.682 13.0832 25.5535L12.5418 25.0121C12.4133 24.8836 12.4133 24.6758 12.5418 24.5473ZM12.5418 20.6371L13.0832 21.1785C13.2117 21.307 13.4196 21.307 13.5481 21.1785L18.5 16.2375L23.452 21.1785C23.5805 21.307 23.7883 21.307 23.9168 21.1785L24.4582 20.6371C24.5867 20.5086 24.5867 20.3008 24.4582 20.1723L18.7324 14.4465C18.6039 14.318 18.3961 14.318 18.2676 14.4465L12.5418 20.1723C12.4133 20.3008 12.4133 20.5086 12.5418 20.6371Z\" fill=\"#c8dbcf\"></path></g></g></svg>", 3)
const _hoisted_93 = [
  _hoisted_90
]
const _hoisted_94 = { class: "bg-white px-6 py-5 text-sm text-gray-400" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "grow" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-medium text-primary" }, "Bemærkninger til tur")
  ])
], -1)
const _hoisted_96 = { key: 0 }
const _hoisted_97 = { class: "m-0 flex items-center p-0" }
const _hoisted_98 = { class: "flex w-full gap-x-4 no-underline py-1.5" }
const _hoisted_99 = { class: "grid grow" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-medium leading-5 text-gray-800" }, null, -1)
const _hoisted_101 = { class: "text-base font-medium leading-5 text-gray-800" }
const _hoisted_102 = {
  key: 1,
  class: "text-primary text-sm"
}
const _hoisted_103 = { class: "bg-white px-6 py-5 text-sm text-gray-400" }
const _hoisted_104 = { class: "flex items-center mb-4" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("div", { class: "grow" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-medium text-primary" }, "Handlingslog på tur")
], -1)
const _hoisted_106 = { class: "grow-0" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("svg", {
  class: "fill-secondary",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M10 5C10.5523 5 11 5.44772 11 6V9L14 9C14.5523 9 15 9.44772 15 10C15 10.5523 14.5523 11 14 11H11V14C11 14.5523 10.5523 15 10 15C9.44771 15 9 14.5523 9 14V11H6C5.44772 11 5 10.5523 5 10C5 9.44771 5.44772 9 6 9L9 9V6C9 5.44772 9.44771 5 10 5Z"
  })
], -1)
const _hoisted_108 = [
  _hoisted_107
]
const _hoisted_109 = { key: 0 }
const _hoisted_110 = { class: "m-0 flex items-center p-0" }
const _hoisted_111 = ["onClick"]
const _hoisted_112 = { class: "grid grow" }
const _hoisted_113 = { class: "text-base font-medium leading-5 text-gray-800" }
const _hoisted_114 = { class: "text-sm truncate text-gray-400" }
const _hoisted_115 = {
  key: 1,
  class: "text-primary text-sm"
}
const _hoisted_116 = /*#__PURE__*/_createElementVNode("li", { class: "bg-white px-6 py-5 text-sm text-gray-400 hidden" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center mb-4" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "grow" }, [
      /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-medium text-primary" }, "Relaterede dokumenter")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "grow-0" })
  ]),
  /*#__PURE__*/_createElementVNode("ul", {
    role: "list",
    class: "divide-y divide-gray-200 border-y border-gray-200 p-0"
  }, [
    /*#__PURE__*/_createElementVNode("li", { class: "m-0 flex items-center p-0" }, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "#",
        class: "flex w-full gap-x-4 no-underline py-1.5"
      }, [
        /*#__PURE__*/_createElementVNode("div", { class: "grid grow" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "text-sm truncate text-gray-400" }, "Trailer certificering"),
          /*#__PURE__*/_createElementVNode("div", { class: "text-base font-medium leading-5 text-gray-800" }, "DJ85517-TestRapport.pdf")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "flex items-center shrink-0" }, [
          /*#__PURE__*/_createElementVNode("button", { class: "p-0 px-3" }, [
            /*#__PURE__*/_createElementVNode("svg", {
              class: "fill-secondary",
              width: "18",
              height: "16",
              viewBox: "0 0 18 16",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              /*#__PURE__*/_createElementVNode("path", { d: "M15.2916 6.42782C15.1791 4.79657 13.8206 3.50001 12.15 3.50001C11.9362 3.50001 11.7253 3.52251 11.52 3.5647C10.6228 2.4397 9.22781 1.70001 7.65 1.70001C5.27063 1.70001 3.27656 3.37907 2.80406 5.63189C1.12219 6.31532 0 7.95501 0 9.80001C0 12.2863 2.01375 14.3 4.5 14.3H13.95C16.1859 14.3 18 12.4859 18 10.25C18 8.51189 16.8975 6.99314 15.2916 6.42782ZM13.95 12.95H4.5C2.75906 12.95 1.35 11.5409 1.35 9.80001C1.35 8.21376 2.52281 6.90032 4.05 6.68095V6.65001C4.05 4.66157 5.66156 3.05001 7.65 3.05001C9.15469 3.05001 10.4428 3.97251 10.98 5.28314C11.295 5.01314 11.7028 4.85001 12.15 4.85001C13.1428 4.85001 13.95 5.6572 13.95 6.65001C13.95 6.98189 13.86 7.29407 13.7025 7.56126C13.7841 7.55282 13.8684 7.55001 13.95 7.55001C15.4406 7.55001 16.65 8.75939 16.65 10.25C16.65 11.7406 15.4406 12.95 13.95 12.95ZM10.7887 7.98876C10.6566 7.85657 10.44 7.85657 10.3078 7.99157L8.775 9.56095V5.63751C8.775 5.45189 8.62313 5.30001 8.4375 5.30001H7.7625C7.57687 5.30001 7.425 5.45189 7.425 5.63751V9.56095L5.89219 7.99157C5.76 7.85657 5.54625 7.85657 5.41125 7.98876L4.93594 8.46407C4.80375 8.59626 4.80375 8.81001 4.93594 8.9422L7.86094 11.8672C7.99312 11.9994 8.20687 11.9994 8.33906 11.8672L11.2641 8.9422C11.3962 8.81001 11.3962 8.59626 11.2641 8.46407L10.7887 7.98876Z" })
            ])
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_117 = /*#__PURE__*/_createElementVNode("section", { class: "flex flex-col bg-gray-50 h-5" }, null, -1)
const _hoisted_118 = {
  key: 0,
  class: "h-full w-full top-0 fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-80"
}
const _hoisted_119 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-6 h-6",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_120 = [
  _hoisted_119
]
const _hoisted_121 = ["href"]
const _hoisted_122 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-6 h-6",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M21.71 11.29l-9-9a.996.996 0 00-1.41 0l-9 9a.996.996 0 000 1.41l9 9c.39.39 1.02.39 1.41 0l9-9a.996.996 0 000-1.41zM14 14.5V12h-4v3H8v-4c0-.55.45-1 1-1h5V7.5l3.5 3.5-3.5 3.5z" })
], -1)
const _hoisted_123 = [
  _hoisted_122
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_headerComponent = _resolveComponent("headerComponent")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_stopDetailsComponent = _resolveComponent("stopDetailsComponent")!
  const _component_logDetailsComponent = _resolveComponent("logDetailsComponent")!
  const _component_washDetailsComponent = _resolveComponent("washDetailsComponent")!
  const _component_checklistComponent = _resolveComponent("checklistComponent")!
  const _component_defrostComponent = _resolveComponent("defrostComponent")!
  const _component_trailerDetailsComponent = _resolveComponent("trailerDetailsComponent")!
  const _component_bookingActionComponent = _resolveComponent("bookingActionComponent")!
  const _component_deviationComponent = _resolveComponent("deviationComponent")!
  const _component_mapComponent = _resolveComponent("mapComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", {
      class: _normalizeClass(["flex flex-col bg-gray-50 h-screen", { 'overflow-hidden': _ctx.isSubComponentOpen }])
    }, [
      _createVNode(_component_headerComponent),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_Transition, {
            "enter-active-class": "transform ease-out duration-300 transition",
            "enter-from-class": "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
            "enter-to-class": "translate-y-0 opacity-100 sm:translate-x-0",
            "leave-active-class": "transition ease-in duration-100",
            "leave-from-class": "opacity-100",
            "leave-to-class": "opacity-0"
          }, {
            default: _withCtx(() => [
              (!_ctx.isActive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("div", {
                          class: "ml-3 w-0 flex-1 pt-0.5",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isActive = true))
                        }, [
                          _createElementVNode("p", _hoisted_7, "Tur køres ikke i dag - " + _toDisplayString(_ctx.formatDate(_ctx.booking.departureDate)), 1),
                          _hoisted_8
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, {
            "enter-active-class": "transform ease-out duration-300 transition",
            "enter-from-class": "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
            "enter-to-class": "translate-y-0 opacity-100 sm:translate-x-0",
            "leave-active-class": "transition ease-in duration-100",
            "leave-from-class": "opacity-100",
            "leave-to-class": "opacity-0"
          }, {
            default: _withCtx(() => [
              (_ctx.showMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createElementVNode("div", {
                          class: "ml-3 w-0 flex-1 pt-0.5",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMessage = false))
                        }, [
                          _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.mediumMessage), 1),
                          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.smallMessage), 1)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("section", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_router_link, { to: '/bookings' }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  (_ctx.booking.isActive)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.handleSelect()), ["stop","prevent"])),
                        class: "z-40 mx-4"
                      }, [
                        _hoisted_20,
                        (_ctx.showSelect)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              ref: "dropdownRef",
                              onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop","prevent"])),
                              class: "absolute right-3 z-20 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none",
                              role: "menu",
                              "aria-orientation": "vertical",
                              "aria-labelledby": "menu-button",
                              tabindex: "-1"
                            }, [
                              (_ctx.checkTrailer)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    _createElementVNode("a", {
                                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.toggleSetTrailer()), ["stop","prevent"])),
                                      class: _normalizeClass(["text-gray-700 block px-4 py-2 text-sm font-medium", { 'opacity-20 pointer-events-none': !_ctx.checkTrailer }]),
                                      role: "menuitem",
                                      disabled: !_ctx.checkTrailer
                                    }, " Skift trailer ", 10, _hoisted_22)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.booking.defrostState >= 0 && _ctx.booking.defrostState < 3)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                    _createElementVNode("a", {
                                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.clickDefrost()), ["stop","prevent"])),
                                      disabled: _ctx.defrost !== null && _ctx.defrost.timeEnded !== null,
                                      class: _normalizeClass([{ 'opacity-20': _ctx.defrost !== null && _ctx.defrost.timeEnded !== null }, "text-gray-700 block px-4 py-2 text-sm font-medium"]),
                                      role: "menuitem"
                                    }, _toDisplayString(_ctx.defrost === null ?
                          'Start defrost' : 'Afslut defrost'), 11, _hoisted_24)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.booking.isMonitoringPaused === false)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    _createElementVNode("a", {
                                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.setBookingActionState('PAUSE')), ["stop","prevent"])),
                                      disabled: !_ctx.checkTourPause,
                                      class: _normalizeClass([{ 'opacity-20 pointer-events-none': !_ctx.checkTourPause }, "text-gray-700 block px-4 py-2 text-sm font-medium"]),
                                      role: "menuitem"
                                    }, "Start pause", 10, _hoisted_26)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.booking.isMonitoringPaused)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                    _createElementVNode("a", {
                                      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.setBookingActionState('RESUME')), ["stop","prevent"])),
                                      class: "text-gray-700 block px-4 py-2 text-sm font-medium",
                                      role: "menuitem"
                                    }, "Stop pause")
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("a", {
                                  onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.setBookingActionState('STOP')), ["stop","prevent"])),
                                  disabled: !_ctx.checkTourStop,
                                  class: _normalizeClass([{ 'opacity-20 pointer-events-none': !_ctx.checkTourStop }, "text-gray-700 block px-4 py-2 text-sm font-medium"]),
                                  role: "menuitem"
                                }, "Afslut tur - intet gods", 10, _hoisted_29)
                              ]),
                              _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("a", {
                                  onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.setBookingActionState('CANCEL')), ["stop","prevent"])),
                                  disabled: !_ctx.checkTourCancel,
                                  class: _normalizeClass([{ 'opacity-20 pointer-events-none': !_ctx.checkTourCancel }, "text-gray-700 block px-4 py-2 text-sm font-medium"]),
                                  role: "menuitem"
                                }, " Afslut tur (Fjern resterende stop)", 10, _hoisted_31)
                              ])
                            ], 512))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.booking.bookingTitle), 1),
                  _createElementVNode("h5", _hoisted_36, _toDisplayString(_ctx.booking.logTypeName) + " - " + _toDisplayString(_ctx.booking.trailerName), 1)
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("ul", _hoisted_37, [
          _createElementVNode("li", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("h1", _hoisted_41, _toDisplayString(_ctx.stopRoute.currentTemperature) + "°", 1),
                _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.stopRoute.temperature) + " sidste 10 min.", 1),
                _createElementVNode("div", _hoisted_43, "Dør: " + _toDisplayString(_ctx.stopRoute.doorState === 'CLOSED' ? 'Lukket' :
                  _ctx.stopRoute.doorState === 'OPEN' ? 'Åben' : _ctx.stopRoute.doorState), 1)
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("button", {
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onClickMap())),
                  class: "flex w-10 h-10 rounded-full bg-secondary items-center justify-center hover:shadow-md"
                }, _hoisted_46)
              ])
            ]),
            (_ctx.showStart > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "w-full h-10 border-b-2 rounded-lg bg-gray-100 flex justify-center items-center cursor-pointer",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.expand('up')))
                }, _hoisted_50))
              : _createCommentVNode("", true),
            (!_ctx.bookingIsCurrent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, _hoisted_54))
              : (_openBlock(), _createElementBlock("ul", _hoisted_55, [
                  (_ctx.booking.defrostState >= 0)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_56, [
                        _hoisted_57,
                        _createElementVNode("a", {
                          onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.clickDefrost()), ["stop","prevent"])),
                          class: "flex w-full z-10 gap-x-4 no-underline py-1.5"
                        }, [
                          _createElementVNode("div", _hoisted_58, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-4 h-4 rounded-full z-10", {
                      'bg-gray-100 pointer-events-none': _ctx.booking.defrostState === 3,
                      'bg-blue-400': _ctx.booking.defrostState > 0 && _ctx.booking.defrostState < 3,
                      'border border-secondary bg-white': _ctx.booking.defrostState === 0
                    }])
                            }, null, 2)
                          ]),
                          _hoisted_59
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.booking.imageStartState >= 0)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_61, [
                        _hoisted_62,
                        _createElementVNode("a", {
                          onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.setBookingActionState('IMAGESTART')), ["stop","prevent"])),
                          class: "flex w-full z-10 gap-x-4 no-underline py-1.5"
                        }, [
                          _createElementVNode("div", _hoisted_63, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-4 h-4 rounded-full z-10", {
                      'bg-gray-100 pointer-events-none': _ctx.booking.imageStartState === 1,
                      'border border-secondary bg-white': _ctx.booking.imageStartState === 0
                    }])
                            }, null, 2)
                          ]),
                          _hoisted_64
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleStops, (stop, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (_ctx.shouldShowPlaceholder(index))
                          ? (_openBlock(), _createElementBlock("li", {
                              key: 0,
                              class: _normalizeClass(["m-0 flex rounded-sm items-center p-0 relative bg-gray-100", { 'bg-red-400': _ctx.activeDeviation || _ctx.booking.currentStop.secondaryAddressId }]),
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.toggleDeviation()))
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass([{ 'bg-red-400': _ctx.activeDeviation || _ctx.booking.currentStop.secondaryAddressId }, "absolute left-2 top-4 z-10 -ml-px mt-0.5 h-full w-0.5 bg-gray-100"]),
                                "aria-hidden": "true"
                              }, null, 2),
                              _createElementVNode("div", _hoisted_66, [
                                _hoisted_67,
                                _createElementVNode("div", _hoisted_68, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["text-base text-gray-400", { 'text-white': _ctx.activeDeviation || _ctx.booking.currentStop.secondaryAddressId }]),
                                    innerHTML: _ctx.deviationText
                                  }, null, 10, _hoisted_69)
                                ]),
                                _hoisted_70
                              ])
                            ], 2))
                          : _createCommentVNode("", true),
                        _createElementVNode("li", _hoisted_71, [
                          _hoisted_72,
                          _createElementVNode("a", {
                            onClick: ($event: any) => (_ctx.showStopDetails(stop)),
                            class: "flex w-full z-10 gap-x-4 no-underline py-1.5"
                          }, [
                            _createElementVNode("div", _hoisted_74, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["w-4 h-4 rounded-full z-10", {
                          'bg-gray-100 pointer-events-none': stop.stopDone,
                          'bg-blue-400': stop.stopStarted && !stop.stopDone,
                          'border border-secondary bg-white': !stop.stopStarted
                        }])
                              }, null, 2)
                            ]),
                            _createElementVNode("div", _hoisted_75, [
                              _createElementVNode("div", _hoisted_76, _toDisplayString(stop.memoInternal !== null && stop.memoInternal !==
                          undefined && stop.memoInternal !== '' ? stop.memoInternal : '-'), 1),
                              _createElementVNode("div", _hoisted_77, _toDisplayString(stop.fromAddressStop), 1)
                            ]),
                            _hoisted_78
                          ], 8, _hoisted_73)
                        ])
                      ], 64))
                    }), 128))
                  ]),
                  (_ctx.booking.imageEndState >= 0)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_79, [
                        _hoisted_80,
                        _createElementVNode("a", {
                          onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.setBookingActionState('IMAGEEND')), ["stop","prevent"])),
                          class: "flex w-full z-10 gap-x-4 no-underline py-1.5"
                        }, [
                          _createElementVNode("div", _hoisted_81, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-4 h-4 rounded-full z-10", {
                      'bg-gray-100 pointer-events-none': _ctx.booking.imageEndState === 1,
                      'border border-secondary bg-white': _ctx.booking.imageEndState === 0
                    }])
                            }, null, 2)
                          ]),
                          _hoisted_82
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", _hoisted_84, [
                    _createElementVNode("a", {
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showWash())),
                      class: "flex w-full z-10 gap-x-4 no-underline py-1.5"
                    }, [
                      _createElementVNode("div", _hoisted_85, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["w-4 h-4 rounded-full z-10", {
                      'bg-gray-100 pointer-events-none': _ctx.booking.washState == 1 || _ctx.booking.status === 3,
                      'border border-secondary bg-white': _ctx.booking.washState == 0 && _ctx.booking.status !== 3
                    }])
                        }, null, 2)
                      ]),
                      _createElementVNode("div", _hoisted_86, [
                        _hoisted_87,
                        _createElementVNode("div", _hoisted_88, _toDisplayString(_ctx.booking.washState == 0 &&
                      _ctx.booking.status < 3 ? 'Registering af vask' : 'Registering af vask er udført'), 1)
                      ]),
                      _hoisted_89
                    ])
                  ])
                ])),
            (_ctx.showEnd < _ctx.booking?.stops?.length)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  class: "w-full h-10 mt-2 border-b-2 rounded-lg bg-gray-100 flex justify-center items-center cursor-pointer",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.expand('down')))
                }, _hoisted_93))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("li", _hoisted_94, [
            _hoisted_95,
            (_ctx.booking.remarks && _ctx.booking.remarks.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.booking.remarks, (remark) => {
                    return (_openBlock(), _createElementBlock("ul", {
                      key: remark.reL_RemarkType,
                      role: "list",
                      class: "divide-y divide-gray-200 border-y border-gray-200 p-0"
                    }, [
                      _createElementVNode("li", _hoisted_97, [
                        _createElementVNode("div", _hoisted_98, [
                          _createElementVNode("div", _hoisted_99, [
                            _hoisted_100,
                            _createElementVNode("div", _hoisted_101, _toDisplayString(remark.remark), 1)
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_102, " Der er ingen bemærkninger "))
          ]),
          _createElementVNode("li", _hoisted_103, [
            _createElementVNode("div", _hoisted_104, [
              _hoisted_105,
              _createElementVNode("div", _hoisted_106, [
                _createElementVNode("button", {
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.addRemark())),
                  class: "flex w-10 h-10 rounded-full border border-secondary items-center justify-center hover:shadow-md"
                }, _hoisted_108)
              ])
            ]),
            (_ctx.logList.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logList, (log) => {
                    return (_openBlock(), _createElementBlock("ul", {
                      key: log.id,
                      role: "list",
                      class: "divide-y divide-gray-200 border-y border-gray-200 p-0"
                    }, [
                      _createElementVNode("li", _hoisted_110, [
                        _createElementVNode("a", {
                          onClick: ($event: any) => (_ctx.openBookingLogDetails(log)),
                          class: "flex w-full gap-x-4 no-underline py-1.5"
                        }, [
                          _createElementVNode("div", _hoisted_112, [
                            _createElementVNode("div", _hoisted_113, _toDisplayString(_ctx.formattedTime(log.timestamp)), 1),
                            _createElementVNode("div", _hoisted_114, _toDisplayString(log.details), 1)
                          ])
                        ], 8, _hoisted_111)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_115, " Der er endnu ingen handlinger "))
          ]),
          _hoisted_116
        ]),
        _hoisted_117
      ]),
      _createVNode(_component_stopDetailsComponent, { isVisible: _ctx.isSubComponentOpen }, null, 8, ["isVisible"]),
      _createVNode(_component_logDetailsComponent, { isVisibleLog: _ctx.isLogComponentOpen }, null, 8, ["isVisibleLog"]),
      _createVNode(_component_washDetailsComponent, { isVisible: _ctx.isWashOpen }, null, 8, ["isVisible"]),
      _createVNode(_component_checklistComponent, { isVisible: _ctx.isChecklistOpen }, null, 8, ["isVisible"]),
      _createVNode(_component_defrostComponent, { isVisibleDefrost: _ctx.isDefrostComponentOpen }, null, 8, ["isVisibleDefrost"]),
      _createVNode(_component_trailerDetailsComponent, { isVisible: _ctx.isTrailerComponentOpen }, null, 8, ["isVisible"]),
      _createVNode(_component_bookingActionComponent, { isVisible: _ctx.hasBookingActionState }, null, 8, ["isVisible"]),
      _createVNode(_component_deviationComponent, {
        isVisibleDeviation: _ctx.isDeviationOpen,
        bookingId: _ctx.id
      }, null, 8, ["isVisibleDeviation", "bookingId"]),
      (_ctx.isMapOverlayVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
            _createVNode(_component_mapComponent),
            _createElementVNode("button", {
              onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.closeMap && _ctx.closeMap(...args))),
              class: "absolute top-5 left-5 bg-primary text-white p-2 rounded-full hover:bg-red-600 focus:outline-none focus:ring-4 focus:ring-red-300"
            }, _hoisted_120),
            (_ctx.googleMapsUrl)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: _ctx.googleMapsUrl,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  title: "Åbn rute i Google Maps",
                  class: "absolute top-5 right-5 bg-primary text-white p-2 rounded-full hover:bg-green-600 focus:outline-none focus:ring-4 focus:ring-green-300"
                }, _hoisted_123, 8, _hoisted_121))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}